import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import HelpCenter from '@/pages/HelpCenter';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate to="/privacy" replace />} />
                <Route path="/:category" element={<HelpCenter />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
